import { render, staticRenderFns } from "./FundingSettingsSection.vue?vue&type=template&id=3a7b6e78&scoped=true"
import script from "./FundingSettingsSection.vue?vue&type=script&lang=js"
export * from "./FundingSettingsSection.vue?vue&type=script&lang=js"
import style0 from "./FundingSettingsSection.vue?vue&type=style&index=0&id=3a7b6e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b6e78",
  null
  
)

export default component.exports